import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Inputfield from "../Textfield/Textfield";
import Buttons from "../Button/Button";
import "./Modal.scss";
import { useTranslation } from "react-i18next";
import { Storage } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import { updateGarment } from "../../graphql/mutations";
import { listProductCategorys } from "../../graphql/queries";
import Snackbar from "../Snackbar/Snackbar";
import { SliderPicker } from "react-color";
import CatergorySelect from "../Multiselect/Categoryselect";
const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 550,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
	border: "1px solid #000",
};

export default function Editmodal({
	setEditmodal,
	editmodal,
	shirtedit,
	settgarments,
	tgarments,
}) {
	const [frtimgaddress, setfrtimageAdress] = useState("");
	const [bckimgaddress, setbckimgaddress] = useState("");
	const [price, setprice] = useState();
	const [shirtname, setshirtname] = useState("");
	const [description, setdescription] = useState();
	const [personName, setPersonName] = useState([]);
	const { t } = useTranslation();
	const [webflowShirt, setwebflowShirt] = useState([]);
	const [webflowData, setwebflowData] = useState([]);
	const [front, setfront] = useState(false);
	const [back, setback] = useState(false);
	const [loader1, setloader1] = useState(false);
	const [msg, setmsg] = useState("");
	const [errMsg, seterrMsg] = useState("");
	const [color, setColor] = useState("#000000");
	const [colArray, setColarr] = useState([]);
	const dataurl1 = [];
	const [categoryData, setcategoryData] = useState([]);
	const [cat, setCat] = React.useState([]);
	const names = [t("shirt"), t("hoodie"), t("streetwear"), t("cotton_bio")];

	useEffect(() => {
		if (shirtedit.category) {
			const category = [];
			cat
				.filter((item) =>
					shirtedit.category.find(
						(catItem) => item.categoryName === catItem.categoryName,
					),
				)
				.map((item) => {
					category.push(item.categoryName);
				});
			setPersonName(category);
		}
	}, [shirtedit]);

	const category = async () => {
		const categorylist = await API.graphql({
			query: listProductCategorys,
			authMode: "API_KEY",
		});
		setCat(categorylist.data.listProductCategorys.items);
	};

	useEffect(() => {
		category();
	}, []);

	useEffect(() => {
		setfrtimageAdress(shirtedit.frontImg);
		setbckimgaddress(shirtedit?.backImg);
		setprice(shirtedit.cost);
		setshirtname(shirtedit?.garmentName?.name);
		setdescription(shirtedit.garmentDescription);
		setColarr(shirtedit.color);
		setcategoryData(shirtedit.category);
	}, [shirtedit]);

	const modalcondFunc = () => {
		setEditmodal(false);
	};

	let frontpic = "";
	let backpic = "";
	const uploadshirt = async (webflowData) => {
		if (front && back) {
			const pic = [frtimgaddress, bckimgaddress];
			for (let index = 0; index < pic?.length; index++) {
				const filename = Date.now();
				const base64Data = new Buffer.from(
					pic[index].replace(/^data:image\/\w+;base64,/, ""),
					"base64",
				);
				const Store = await Storage.put(
					"designproducts/" + filename,
					base64Data,
					{
						ContentEncoding: "base64",
						ContentType: `image/png`,
						Acl: "public-read",
						contentDisposition: "inline",
					},
				);
				const url = await Storage.get(Store.key);
				dataurl1.push(url.split("?")[0]);
			}
		} else if (front) {
			const filename = Date.now();
			const base64Data = new Buffer.from(
				frtimgaddress.replace(/^data:image\/\w+;base64,/, ""),
				"base64",
			);
			const Store = await Storage.put(
				"designproducts/" + filename,
				base64Data,
				{
					ContentEncoding: "base64",
					ContentType: `image/png`,
					Acl: "public-read",
					contentDisposition: "inline",
				},
			);
			const url = await Storage.get(Store.key);
			frontpic = url.split("?")[0];
		} else if (back) {
			const filename = Date.now();
			const base64Data = new Buffer.from(
				bckimgaddress.replace(/^data:image\/\w+;base64,/, ""),
				"base64",
			);
			const Store = await Storage.put(
				"designproducts/" + filename,
				base64Data,
				{
					ContentEncoding: "base64",
					ContentType: `image/png`,
					Acl: "public-read",
					contentDisposition: "inline",
				},
			);
			const url = await Storage.get(Store.key);
			backpic = url.split("?")[0];
		}
		const garment = await {
			id: shirtedit.id,
			frontImg: front && back ? dataurl1[0] : front ? frontpic : frtimgaddress,
			backImg: front && back ? dataurl1[1] : back ? backpic : bckimgaddress,
			frontImgaddress:
				front && back
					? dataurl1[0].split("public/")[1]
					: frtimgaddress.split("public/")[1],
			backImgaddress:
				front && back
					? dataurl1[1].split("public/")[1]
					: bckimgaddress.split("public/")[1],
			garmentName: {
				name: webflowData.name,
				id: webflowData._id,
			},
			cost: price,
			category: categoryData,
			garmentDescription: description,
			color: colArray,
		};
		try {
			const data = await API.graphql(
				graphqlOperation(updateGarment, { input: garment }),
			);
			setmsg("Successfully added");
			setfrtimageAdress("");
			setbckimgaddress("");
			setfront(false);
			setback(false);
			setloader1(false);
			setTimeout(() => {
				setmsg("");
			}, 15000);

			tgarments?.filter((val, ind) => {
				if (val?.id === data?.data.updateGarment.id) {
					tgarments.splice(ind, 1, data?.data.updateGarment);
					let newdata = [...tgarments];
					settgarments(newdata);
				}
			});
		} catch (error) {
			seterrMsg(error.message);
			setloader1(false);
			setfront(false);
			setback(false);
			setTimeout(() => {
				seterrMsg("");
			}, 1500);
		}
		setEditmodal(false);
	};

	useEffect(() => {
		API.get("laetusapi", "/api/v1/getshirtname")
			.then((res) => {
				setwebflowShirt(res.items);
			})
			.catch((err) => {
				return err;
			});
	}, []);
	const handleimagefrt = (e) => {
		setfront(true);
		var reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = function () {
			setfrtimageAdress(reader.result);
		};
	};
	const handleimagebck = (e) => {
		setback(true);
		var reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = function () {
			setbckimgaddress(reader.result);
		};
	};
	const handlepriceChange = (e) => {
		setprice(e.target.value);
	};
	const handlenameChange = (e) => {
		setshirtname(e.target.value);
	};
	const handledescChange = (e) => {
		setdescription(e.target.value);
	};

	const clrDel = (ind) => {
		setColarr((prev) => prev.filter((exp, index) => index !== ind));
	};

	const shirtUpload = () => {
		seterrMsg("");
		setmsg("");
		if (shirtname.length < 25) {
			setloader1(true);
			if (webflowData.length > 0) {
				uploadshirt(webflowData[0]);
			} else {
				API.post("laetusapi", "/api/v1/addshirtname", {
					body: {
						shirtname: shirtname,
					},
				})
					.then((res) => {})
					.catch((err) => {
						setloader1(false);
					});
			}
		} else {
			seterrMsg(t("required-fields"));
			setTimeout(() => {
				seterrMsg("");
			}, 2000);
		}
	};

	useEffect(() => {
		const data = webflowShirt.filter((data) => data.name === shirtname);
		setwebflowData(data);
	}, [shirtname]);

	return (
		<div>
			<Modal
				open={editmodal}
				onClose={modalcondFunc}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<div className="congrat">
						<div className="garments-img">
							<div>
								{frtimgaddress && (
									<img
										src={frtimgaddress}
										alt="profile-img"
										width={200}
										height={200}
										style={{ borderRadius: "10%" }}
									/>
								)}
								<label>
									<input
										type="file"
										onChange={(e) => handleimagefrt(e)}
										style={{ display: "none" }}
										accept="image/png"
									/>
									<br />
									<span className="title">{t("upload-front")}</span>
								</label>
							</div>
							<div>
								{bckimgaddress && (
									<img
										src={bckimgaddress}
										alt="profile-img"
										width={200}
										height={200}
										style={{ borderRadius: "10%" }}
									/>
								)}
								<label>
									<input
										type="file"
										onChange={(e) => handleimagebck(e)}
										style={{ display: "none" }}
										accept="image/png"
									/>
									<br />
									<span className="title">{t("upload-back")}</span>
								</label>
							</div>
						</div>
						{frtimgaddress && bckimgaddress && (
							<>
								<div className="d-flex" style={{ marginTop: "20px" }}>
									<div className="d-flex ">
										<Inputfield
											type="number"
											placeholder={t("cost-placeholder")}
											onChange={(e) => handlepriceChange(e)}
											value={price}
										/>

										<span
											className="align-center"
											style={{ paddingLeft: "4px" }}
										>
											{" "}
											€
										</span>
									</div>
									<div className="align-center">
										<CatergorySelect
											personName={personName}
											setPersonName={setPersonName}
											setcategoryData={setcategoryData}
										/>
									</div>
								</div>
								<div>
									<SliderPicker
										color={color}
										onChange={(e) => setColor(e.hex)}
										onChangeComplete={(e) => setColor(e.hex)}
									/>
								</div>
								<div style={{ display: "flex" }}>
									<Inputfield
										type="text"
										onChange={(e) => {
											setColor(e.target.value);
										}}
										value={color}
									/>
									<div className="colordiv" style={{ background: color }}></div>
									<div style={{ marginTop: "11px", marginLeft: "10px" }}>
										<Buttons
											text="Add"
											onClick={() => setColarr((prev) => [...prev, color])}
										/>
									</div>
								</div>
								<div
									style={{
										display: "flex",
										flexWrap: "wrap",
										marginLeft: "14px",
									}}
								>
									{colArray?.map((data, ind) => {
										return (
											<div className="clr-span-div">
												<span
													key={ind}
													className="clr-span"
													style={{
														background: data,
													}}
												></span>
												<span>{data}</span>
												<span className="cancel cp" onClick={() => clrDel(ind)}>
													x
												</span>
											</div>
										);
									})}
								</div>
								<div>
									<Inputfield
										type="text"
										placeholder={t("garmentname-placeholder")}
										onChange={(e) => handlenameChange(e)}
										value={shirtname}
									/>
								</div>
								{shirtname.length > 25 && (
									<span className="cost-err">{t("name-lenght")}</span>
								)}
								<div>
									<Inputfield
										type="text"
										placeholder={t("garmentdesc-placeholder")}
										onChange={(e) => handledescChange(e)}
										value={description}
									/>
								</div>
								<div style={{ textAlign: "center" }}>
									{personName.length > 0 &&
										colArray.length > 0 &&
										description &&
										shirtname && (
											<Buttons
												text={`> ${t("modify_campaign")}`}
												className="modifier btn btnclr"
												onClick={() => shirtUpload()}
												loader={loader1}
											/>
										)}
								</div>
							</>
						)}
					</div>
				</Box>
			</Modal>
			{msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
		</div>
	);
}
